import { Alert, Collapse } from '@mui/material';
import React from 'react';
import { useEffect, useState } from 'react';

interface StatusMessageProps {
  show: boolean;
  severity: Severity;
  message: string;
  duration?: number;
  onClose?: () => void;
}

type Severity = 'success' | 'error' | 'info' | 'warning';

const StatusMessage = ({ show, severity, message, duration = 5000, onClose }: StatusMessageProps) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => {
    if (!visible) return;

    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [visible, duration, onClose]);

  if (!message) return null;

  return (
    <Collapse in={visible} sx={{ mb: 2 }}>
      <Alert
        severity={severity}
        onClose={() => {
          setVisible(false);
          onClose?.();
        }}
      >
        {message}
      </Alert>
    </Collapse>
  );
};

export default StatusMessage;
